export default __webpack_public_path__ + "408eada197e69d96675ed59f40ba98d9.png";